import React, { Suspense, lazy, useEffect, useState, useRef } from 'react';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//inview
import { useInView } from 'react-intersection-observer';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//switch
import 'src/asset/scss/plugin/switch.scss';
import Switch from "react-switch";
//style
import styles from 'src/asset/scss/style/user.mypage.module.scss'
//hook
import useVehicleRegHook from 'src/webapp/hooks/vehicle/vehicleReg.hook';
//store
import useComnStore from 'src/webapp/stores/comn.store';
import usePartnerStore from 'src/webapp/stores/partner.store';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import SubTitleBar from 'src/webapp/views/component/title/SubTitleBar';//서브타이틀
import EmptyData from 'src/webapp/views/component/EmptyData';//데이터없음
const _bsVehicleRegBrand = lazy(() => import('src/webapp/views/vehicle/BsVehicleRegBrand'), { ssr: false });//취급차량브랜드
const _bsVehicleRegModel = lazy(() => import('src/webapp/views/vehicle/BsVehicleRegModel'), { ssr: false });//취급차량브랜드-모델
const _bsVehicleRegSuccess = lazy(() => import('src/webapp/views/vehicle/BsVehicleRegSuccess'), { ssr: false });//취급차량등록완료

export default React.memo(function VehicleList() {
    const { axiosPostHandler } = useAxiosHook();//axios
    const { setMessage } = useComnStore();//메세지결과처리
    const { isState, partner } = usePartnerStore();//store
    //Hook
    const { isOpen//팝업오픈여부
        , changeOpenHandler//팝업화면전환핸들러
        , onDismissHandler//팝업off핸들러
        , brandItem//선택브랜드useState
        , handleBrandChange//모델선택핸들러
    } = useVehicleRegHook();
    
    /* =============== 취급차량리스트 최초로딩 =============== */
    const [ inViewRef, inView ] = useInView({ threshold: .3 });
    useEffect(() => {
        if(!isState || !inView || vehicleGroupList.length > 0) { return; }

        vehicleGroupListAPI();//공지사항리스트API
    }, [inView]);
    /* =============== 취급차량리스트 최초로딩 =============== */
    /* =============== 취급차량리스트 =============== */
    const [ vehicleGroupList, setVehicleGroupList ] = useState([]);
    const vehicleGroupListAPI = async() => {
        const DATA = { PARTNER_CD:partner.COMN_CD };
        const result = await axiosPostHandler(`partnerVehicleGroupListForPartner.do`, DATA);
        if(!result || result.message !== "SUCCESS") { return; }
        if(result.message === "SUCCESS") {
            setVehicleGroupList(result.data);
        }
    };
    /* =============== 취급차량리스트 =============== */
    /* =============== 취급차량 활성 및 비활성화 업데이트 =============== */
    const isLock = useRef(false);
    const vehicleUpdateAPI = async(item, index) => {
        if(isLock.current) { return; }

        isLock.current = true;
        const DATA = { PARTNER_CD:partner.COMN_CD, BRAND_CD:item.BRAND_CD, USE_YN:item.USE_YN === 'Y' ? 'N' : 'Y' };
        const result = await axiosPostHandler(`partnerVehicleGroupUpdateForPartner.do`, DATA);
        isLock.current = false;
        if(!result || result.message !== "SUCCESS") { return; }
        if(result.message === "SUCCESS") {
            let newList = [...vehicleGroupList];
            newList[index].USE_YN = DATA.USE_YN;
            setVehicleGroupList(newList);
            setMessage({type:1, message:`취급차량이 업데이트 되었습니다.`});
        }
    };
    /* =============== 취급차량 활성 및 비활성화 업데이트 =============== */

    return (
        <>
        <Element tag={`div`} propRef={inViewRef}  className={styles.vehicleContainer}>
            <SubTitleBar title={`취급차량(${vehicleGroupList.length})`}>
                <button onClick={(e) => changeOpenHandler("brand")}><FontAwesomeIcon icon="fa-light fa-plus" /><Element tag={`span`}>등록하기</Element></button>
            </SubTitleBar>
            {vehicleGroupList.length > 0 ?
                <Element tag={`ul`}>
                    {vehicleGroupList.map((item, idx) => 
                        <Element tag={`li`} key={idx}>
                            <Element tag={`label`}>{item.BRAND_ENG_NAME}</Element>
                            <Element tag={`div`}>
                                <Element tag={`small`}>{item.MODEL_KOR_NAME}</Element>
                                <Switch checked={item.USE_YN === "Y" ? true : false}
                                    onChange={(e) => vehicleUpdateAPI(item, idx)}
                                    width={40} height={20}
                                    offColor={`#737373`} onColor={`#FFD400`}
                                    handleDiameter={16} checkedIcon={false} uncheckedIcon={false}
                                    activeBoxShadow={''} />
                            </Element>
                        </Element>
                    )}
                </Element>
            : <Element tag={`div`} className={styles.emptyData}><EmptyData content={`취급차량은`} /></Element> }
        </Element>

        {/* 차량등록 bottomSheet */}
        {isOpen.brand ? <Suspense fallback={null}><_bsVehicleRegBrand isOpen={isOpen.brand} onBrand={handleBrandChange} onDismiss={onDismissHandler} /></Suspense> : null}
        {isOpen.model ? <Suspense fallback={null}><_bsVehicleRegModel isOpen={isOpen.model} brand={brandItem} onSuccess={vehicleGroupListAPI} onDismiss={onDismissHandler} /></Suspense> : null}
        {isOpen.success ? <Suspense fallback={null}><_bsVehicleRegSuccess isOpen={isOpen.success} onDismiss={onDismissHandler} /></Suspense> : null}
        </>
    );
});